import { Table as TableComponent } from './Table';

export const Table = TableComponent;
